import { Button, Fade, IconButton, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { MoneyFormat } from "../../library/MoneyFormat";
import printJS from "print-js";
import moment from "moment";
import { ToWords } from "to-words";

const PreviewGstCreditNote = ({
  open,
  setOpen,
  companyDetails,
  totAmount,
  creditNoteNumber,
  totNetAmount,
  data,
  itemEntry,
  items,
  nonItems,
  totTaxableAmount,
  totGST,
  totGstCess,
  companyLogo,
  billingAddressDetails,
  deliveryAddressDetails,
  stateName,
  countryName,
  stateDelName,
  countryDelName,
  bankDetails,
  partyDetails,
  stateOfSupply,
  nonItemwiseTableAmount,
  tabelTotAmount,
  companyState,
}) => {
  const toWords = new ToWords();
  const style = {
    position: "absolute",
    left: "10%",
    right: "10%",
    // transform: 'translate(-50%, -50%)',
    bgcolor: "background.paper",
    boxShadow: 24,
    // p: 4,
    outline: "none",
    overflow: "scroll",
    height: "100%",
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const handlePrint = () => {
    setOpen(false);
    printJS({
      printable: html,
      type: "raw-html",
      documentTitle: "Credit Note",
    });
  };

  //   const html = `
  //    <html>
  // <head>
  //     <meta name="viewport" />
  // </head>
  // <body>
  // <div style="min-height: 350px; margin-left: auto; margin-right: auto; width:95%;
  // margin-left: auto; margin-right: auto; padding-top: 10px">
  // <div style="width: 50%; float: left;">
  // <div style="display: flex; flex-direction:column; padding-right: 25px">
  // <span style="display:flex; flex-direction:row; justify-content: center">
  // <img width="200px;height="200px"; src="${companyLogo}"
  // alt="CompanyLogo">
  // </span>
  // <span style="font-size: 25px; padding-bottom: 5px;
  //          display:flex; flex-direction:row; justify-content: center">
  //     ${companyDetails.getCompany?.CompanyName}
  // </span>
  // <span style="font-size: 25px; padding-bottom: 50px;
  //          display:flex; flex-direction:row; justify-content: center">
  //          ${companyDetails.getCompany?.relatedAddressEntity?.[0].Line1.replace(/[**   ,]+/g, ",").slice(0,-1)
  //         //   .split(
  //         //    "**"
  //         //  ).join("\n")
  //         }
  //          ${
  //            companyDetails.getCompany?.relatedAddressEntity?.[0].Line2 &&
  //            ", " +
  //              companyDetails.getCompany?.relatedAddressEntity?.[0].Line2.split(
  //                "**"
  //              ).join("\n")
  //          }
  //          ${
  //            companyDetails.getCompany?.relatedAddressEntity?.[0].Line2 &&
  //            ", " +
  //              companyDetails.getCompany?.relatedAddressEntity?.[0].Line3.split(
  //                "**"
  //              ).join("\n")
  //          }
  //          ${
  //            companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode &&
  //            -companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode.split(
  //              "**"
  //            ).join("\n")
  //          }
  // </span>
  // <div style="font-size: 30px; padding-left: 10px;
  //          display:flex; flex-direction:column;">
  //          <div style="display: flex; flex-direction: row;">
  //          <span style="font-size: 15px; padding-bottom: 5px;">
  //              <strong>GST No : </strong>${
  //                companyDetails.getCompany?.relatedCompanyEntity?.[0].GSTIN
  //              }
  //          </span>
  //      </div>
  // </div>
  // </div>
  // </div>
  // <div style="width: 50%; float: right;">
  // <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  // border-left: none; border-right: none; border-top: none; display: flex;
  // flex-direction:row; justify-content: flex-end; padding-right: 25px">
  // <span style="font-size: 30px; font-weight: bolder;  padding-bottom: 10px;">
  //     CREDIT NOTE
  // </span>
  // </div>
  // <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  // border-left: none; border-right: none; border-top: none; display: flex;
  // flex-direction:row; justify-content: space-between; padding: 10px">
  // <div style="display: flex; flex-direction:column; ">
  //     <span style="font-size: 15px; padding-bottom: 5px;">
  //         Credit Note No:
  //     </span>
  //     <span style="font-size: 18px; font-weight: bold">
  //     ${creditNoteNumber}
  //     </span>
  // </div>
  // <div style="display: flex; flex-direction:column; ">
  //     <span style="font-size: 15px;  padding-bottom: 5px; text-align:right;">
  //         Date & Time
  //     </span>
  //     <span style="font-size: 18px; font-weight: bold">
  //     ${moment(new Date()).format("DD/MMM/YYYY hh:mm A")}
  //     </span>
  // </div>
  // </div>
  // <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  // border-left: none; border-right: none; border-top: none; display: flex;
  // flex-direction:row; justify-content: space-between; padding:10px">
  // <div style="display: flex; flex-direction:column; ">
  //     <span style="font-size: 15px; padding-bottom: 5px;">
  //         Payment Mode
  //     </span>
  //     <span style="font-size: 18px; font-weight: bold">
  //         ${data.paymentType}
  //     </span>
  // </div>
  // <div style="display: flex; flex-direction:column; ">
  //     <span style="font-size: 15px;  padding-bottom: 5px;">
  //     ${data.paymentType === "Credit" ? "Due Date" : "Payment Date"}

  //     </span>
  //     <span style="font-size: 18px; font-weight: bold">
  //             ${
  //               data.paymentType === "Credit"
  //                 ? `${data.dueDate}`
  //                 : `${
  //                     data.invoiceDate === ""
  //                       ? moment(new Date()).format("DD/MMM/YYYY")
  //                       : moment(data.invoiceDate).format("DD/MMM/YYYY")
  //                   }`
  //             }
  //     </span>
  // </div>
  // </div>
  // <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  // border-left: none; border-right: none; border-top: none; display: flex;
  // flex-direction:row; justify-content: space-between; padding:10px">
  // <div style="display: flex; flex-direction:column; ">
  //     <span style="font-size: 15px; padding-bottom: 5px;">
  //         Party Name : ${data?.partyName?.label}
  //     </span>
  //     <span style="font-size: 15px; padding-bottom: 5px;">
  //         GST Registration Number : ${data?.gstin}
  //     </span>
  //     <span style="font-size: 15px; padding-bottom: 5px;">
  //         Place of Supply / State Code : ${data?.placeOfSupply}
  //     </span>
  // </div>
  // </div>
  // <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
  //     <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
  //     <div style="display: flex; flex-direction:column;">
  //         <span style="font-size: 15px; padding-bottom: 5px;">
  //             <strong>Supplier Address</strong>
  //         </span>
  //         ${data.partyName.value != "" ? (
  //         `
  //            <span

  //            >
  //              ${billingAddressDetails.billingAddress !== ""
  //                ? billingAddressDetails.billingAddress.replace(
  //                  /[**  ,]+/g,
  //                  ","
  //                )
  //                : data.billingAddress.replace(/[**  ,]+/g, ",")}
  //            </span>
  //            ${billingAddressDetails.stateCD !== "" || stateName !== "" ? (
  //              `
  //              <span

  //              >
  //                ${billingAddressDetails.stateCD !== ""
  //                  ? billingAddressDetails.stateCD
  //                  : stateName}
  //                ,${countryName}
  //              </span>
  //              `
  //            ) : (
  //             ` <span

  //              >
  //                ${countryName}
  //              </span>`
  //            )}
  //            `

  //        ):(``)}
  //     </div>
  //     </div>
  //     <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
  //     <div style="display: flex; flex-direction:column; ">
  //         <span style="font-size: 15px; padding-bottom: 5px;">
  //             <strong>Delivery Address</strong>
  //         </span>
  //         ${data.partyName.value != "" ? (
  //          `

  //            <span

  //            >
  //              ${deliveryAddressDetails.deliveryAddress !== ""
  //                ? deliveryAddressDetails.deliveryAddress.replace(
  //                  /[**  ,]+/g,
  //                  ","
  //                )
  //                : data.deliveryAddress.replace(/[**  ,]+/g, ",")}
  //            </span>
  //            ${deliveryAddressDetails.stateCD != "" || stateDelName !== "" ? (
  //              `
  //              <span

  //              >
  //                ${deliveryAddressDetails.stateCD != ""
  //                  ? deliveryAddressDetails.stateCD
  //                  : stateDelName}
  //                ,${countryDelName}
  //              </span>`
  //            ) : (`
  //              <span

  //              >
  //                ${countryDelName}
  //              </span>`
  //            )}
  //      `
  //        ):(``)}
  //     </div>
  //     </div>
  //     </div>
  // </div>
  // </div>
  //     ${
  //       itemEntry
  //         ? `<table border="1" cellpadding="5" cellspacing= "0" width="95%"
  //            style="margin-left: auto; margin-right: auto; text-align: center;">
  //         <thead style="background-color: #DADBDD; font-weight: bold;">
  //             <tr>
  //                 <td>#</td>
  //                 <td>Item Name</td>
  //                 <td>HSN Code</td>
  //                 <td>Rate</td>
  //                 <td>Qty</td>
  //                 <td>Discount</td>
  //                 <td>Gross Amt</td>
  //                 <td>GST Rate </td>
  //                 <td colspan="2">CGST</td>
  //                 <td colspan="2">SGST</td>
  //                 <td colspan="2">IGST</td>
  //                 <td style="text-align:right">Total</td>
  //             </tr>
  //             <tr>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td>Rate</td>
  //                 <td>Amount</td>
  //                 <td>Rate</td>
  //                 <td>Amount</td>
  //                 <td>Rate</td>
  //                 <td>Amount</td>
  //                 <td></td>
  //             </tr>
  //         </thead>
  //         <tbody>
  //             ${
  //               items &&
  //               items.length > 0 &&
  //               items.map((item, index) => {
  //                 return `<tr style="min-height: 100px">
  //                     <td>${index + 1}</td>
  //                     <td>${item.name.label}</td>
  //                     <td>${item.HSN.value}</td>
  //                     <td>${item.rate}</td>
  //                     <td>${item.qty}</td>
  //                     <td>${item.dicount}</td>
  //                     <td>${item.amount}</td>
  //                     <td>${item.GSTRate}</td>
  //                     <td>${item.CGST}</td>
  //                 <td>${
  //                   data.placeOfSupply === "companyState"
  //                     ? (
  //                         (Number(item.taxableAMount) * Number(item.GSTRate)) /
  //                         200
  //                       ).toFixed(2)
  //                     : "0.00"
  //                 }
  //                     </td>
  //                     <td>${item.SGST}</td>
  //                     <td>${
  //                       data.placeOfSupply === "companyState"
  //                         ? (
  //                             (Number(item.taxableAMount) *
  //                               Number(item.GSTRate)) /
  //                             200
  //                           ).toFixed(2)
  //                         : "0.00"
  //                     }
  //                     </td>
  //                     <td>${item.IGST}</td>
  //                     <td>${
  //                       data.placeOfSupply !== "companyState"
  //                         ? (
  //                             (Number(item.taxableAMount) *
  //                               Number(item.GSTRate)) /
  //                             100
  //                           ).toFixed(2)
  //                         : "0.00"
  //                     }
  //                     </td>
  //                     <td>${item.netAmount}</td>
  //                 </tr>`;
  //               })
  //             }
  //         </tbody>
  //         <tfoot style="font-weight: bold; background-color: #DADBDD;">
  //             <tr>
  //                 <td colspan="5" style="text-align: right">TOTAL</td>
  //                 <td></td>
  //                 <td>${Number(totAmount).toFixed(2)}</td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td></td>
  //                 <td>${Number(totNetAmount).toFixed(2)}</td>
  //             </tr>
  //         </tfoot>
  //     </table>`
  //         : `<table border="1" cellpadding="5" cellspacing= "0" width="95%"
  //         style="margin-left: auto; margin-right: auto; text-align: center;">
  //         <thead style="background-color: #DADBDD; font-weight: bold;">
  //             <tr>
  //                 <td>#</td>
  //                 <td>Expense Ledger Account</td>
  //                 <td>HSN/SAC Code</td>
  //                 <td>Description</td>
  //                 <td>Taxable Amount</td>
  //                 <td>GST Rate</td>
  //                 <td>GST</td>
  //                 <td>GST Cess</td>
  //                 <td>Net Amount</td>
  //             </tr>
  //         </thead>
  //         <tbody>
  //             ${
  //               nonItems &&
  //               nonItems.length > 0 &&
  //               nonItems.map((item, index) => {
  //                 return `<tr style="min-height: 100px">
  //                 <td>${index + 1}</td>
  //                 <td>${item.ledgerAccount.label}</td>
  //                 <td>${item.HSN.value}</td>
  //                 <td>${item.description}</td>
  //                 <td>${item.taxAMount}</td>
  //                 <td>${item.GSTRate}</td>
  //                 <td>
  //                 ${
  //                   data.placeOfSupply == "companyState"
  //                     ? MoneyFormat(
  //                         (Number(item.taxAMount) * Number(item.GSTRate / 100)) /
  //                           2 +
  //                           (Number(item.taxAMount) *
  //                             Number(item.GSTRate / 100)) /
  //                             2,
  //                         "en-IN"
  //                       )
  //                     : MoneyFormat(
  //                         Number(item.taxAMount) * Number(item.GSTRate / 100),
  //                         "en-IN"
  //                       )
  //                 }
  //                 </td>
  //                 <td>${Number(item?.GSTCess).toFixed(2)}</td>
  //                 <td>${Number(item?.netAmount).toFixed(2)}</td>
  //             </tr>`;
  //               })
  //             }
  //         </tbody>
  //         <tfoot style="font-weight: bold; background-color: #DADBDD;">
  //             <tr>
  //                 <td colspan="4" style="text-align: right">TOTAL</td>
  //                 <td>${Number(totTaxableAmount).toFixed(2)}</td>
  //                 <td></td>
  //                 <td>${Number(totGST).toFixed(2)}</td>
  //                 <td>${Number(totGstCess).toFixed(2)}</td>
  //                 <td>${Number(totNetAmount).toFixed(2)}</td>
  //             </tr>
  //         </tfoot>
  //     </table>`
  //     }
  //     <div style="min-height: 300px; margin-left: auto; margin-right: auto; width:95%;
  //                 border: double; border-width: 2px; border-color: black; margin-top: 15px">
  //                 <div style=" display: flex;">
  //                 <div style="width: 50%;">
  //             <div style="font-size: 17px; margin-top: 10px; margin-bottom: 25px; padding-left: 10px;">
  //                 IN WORDS : <strong>
  //                 ${toWords.convert(
  //                   Number(totNetAmount.toFixed(2)) + Number(data.adjustments)
  //                 )}
  //                 </strong>
  //             </div>
  //             <table border="1" cellpadding="5" width="95%"
  //                    style="text-align: center; margin-left: 10px">
  //                 <thead>
  //                     <tr style="font-weight: bold;">
  //                         <td>Particulars</td>
  //                         <td>Amount</td>
  //                         <td>CGST</td>
  //                         <td>SGST</td>
  //                         <td>IGST</td>
  //                     </tr>
  //                 </thead>
  //                 <tbody>
  //                     <tr>
  //                         <td>Taxable</td>
  //                         <td>${Number(totTaxableAmount).toFixed(2)}</td>
  //                         <td>${
  //                           data.placeOfSupply === "companyState"
  //                             ? (Number(totGST) / 2).toFixed(2)
  //                             : "0.00"
  //                         }</td>
  //                         <td>${
  //                           data.placeOfSupply === "companyState"
  //                             ? (Number(totGST) / 2).toFixed(2)
  //                             : "0.00"
  //                         }</td>
  //                         <td>${
  //                           data.placeOfSupply !== "companyState"
  //                             ? Number(totGST).toFixed(2)
  //                             : "0.00"
  //                         }</td>
  //                     </tr>
  //                 </tbody>
  //             </table>
  //         </div>
  //         <div style="width: 50%; float: right;">
  //             <div style="display: flex; flex-direction:column; line-height: 1.8; ">
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>Gross Value</span>
  //                     <span>${Number(totTaxableAmount).toFixed(2)}</span>
  //                 </div>
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>Net Taxable Value</span>
  //                     <span>${(Number(totGST) + Number(totGstCess)).toFixed(
  //                       2
  //                     )}</span>
  //                 </div>
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>Other Adjustments</span>
  //                     <span>${Number(data.adjustments).toFixed(2)}</span>
  //                 </div>
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>Discount</span>
  //                     <span>${
  //                       Number(totAmount) - Number(totTaxableAmount) > 0
  //                         ? (
  //                             Number(totAmount) - Number(totTaxableAmount)
  //                           ).toFixed(2)
  //                         : "0.00"
  //                     }</span>
  //                 </div>
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>CGST</span>
  //                     <span>${
  //                       data.placeOfSupply === "companyState"
  //                         ? (Number(totGST) / 2).toFixed(2)
  //                         : "0.00"
  //                     }</span>
  //                 </div>
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>SGST</span>
  //                     <span>${
  //                       data.placeOfSupply === "companyState"
  //                         ? (Number(totGST) / 2).toFixed(2)
  //                         : "0.00"
  //                     }</span>
  //                 </div>
  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <span>IGST</span>
  //                     <span>${
  //                       data.placeOfSupply !== "companyState"
  //                         ? Number(totGST).toFixed(2)
  //                         : "0.00"
  //                     }</span>
  //                 </div>

  //                 <div style="display: flex; flex-direction:row; justify-content: space-between;
  //                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
  //                     <strong>Gross Total</strong>
  //                     <strong>${(
  //                       Number(totNetAmount.toFixed(2)) + Number(data.adjustments)
  //                     ).toFixed(2)}</strong>
  //                 </div>
  //             </div>
  //         </div>
  //     </div>
  //     <div style="font-size: 17px; padding-left: 10px;">
  //     Customer Ref / Remarks : <strong> ${data.remarks} </strong>
  // </div>
  // </div>
  //     <div style="margin-left: auto; margin-right: auto; width:95%;
  //                 border: double; border-width: 2px; border-color: black; margin-top: 15px">
  //         <div style="padding:10px;">
  //             <strong>TERMS AND CONDITIONS : </strong>
  //             Lorem Ipsum is simply dummy text of the printing and typesetting industry.
  //             Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
  //             when an unknown printer took a galley of type and scrambled it to make a type specimen book.
  //             It has survived not only five centuries, but also the leap into electronic typesetting,
  //             remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset
  //             sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
  //             Aldus PageMaker including versions of Lorem Ipsum.
  //         </div>
  //     </div>
  //     <div style="margin-left: auto; margin-right: auto; width:95%; display:flex; flex-direction:row;">
  //         <div style="width: 40%; padding:5px; border: 1px solid black;">
  //             <span>
  //                 <strong>DECLARATION : </strong>
  //                 It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
  //             </span>
  //         </div>
  //         <div style="width: 35%; padding:5px; border: 1px solid black;">
  //             <div display:flex; flex-direction:column;>
  //                 <div style="text-align: center;">
  //                     <strong>Received The Item In Good Condition</strong>
  //                 </div>
  //                 <div style="margin-top: 15px; text-align: center;">
  //                     Customer Name and Signature
  //                 </div>
  //             </div>
  //         </div>
  //         <div style="width: 25%; padding:5px; border: 1px solid black;">
  //             <div display:flex; flex-direction:column;>
  //                 <div style="text-align: center;">
  //                     <strong>For ${companyDetails?.getCompany?.CompanyName.toUpperCase()}</strong>
  //                 </div>
  //                 <div style="margin-top: 15px; text-align: center;">
  //                     Authorized Signature
  //                 </div>
  //             </div>
  //         </div>
  //     </div>
  // </body>
  // </html>
  //    `;
  const html = `
    <html>
<head>
    <meta name="viewport" />
</head>
<body>
    <div style="min-height: 350px; margin-left: auto; margin-right: auto; width:95%;
margin-left: auto; margin-right: auto; padding-top: 10px">
        <div style="float: center;">
        <div style="display: flex; flex-direction:column; padding-right: 25px">

        ${
          companyDetails?.getCompany?.relatedCompanyDetailsNew?.[0]
            .CompanyLogoUrl == `https://ledgerx365.s3.amazonaws.com/`
            ? `
        <span style="display:flex; flex-direction:row; justify-content: center">
        <img src="data:image/png;base64,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" 
        alt="CompanyLogo">
        </span>
        `
            : `<span style="display:flex; flex-direction:row; justify-content: center">
        <img src="${companyDetails?.getCompany?.relatedCompanyDetailsNew?.[0].CompanyLogoUrl}"
        alt="CompanyLogo" width="100px" height="100px">
        </span>
        `
        }
        <span style="font-size: 25px; padding-bottom: 5px;
        text-align: center; font-weight:bold;">
         ${companyDetails.getCompany?.CompanyName}
        </span>
        <span style="font-size: 20px; text-align: center;">
              ${companyDetails.getCompany?.relatedAddressEntity?.[0].Line1?.replace(
                /[**   ,]+/g,
                ","
              )
                .slice(0, -1)
                .split(",")
                .join("<br />")}</span>
              <span style="font-size: 20px;
              text-align: center;">${
                companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode &&
                companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode?.split(
                  "**"
                ).join("\n")
              }
        </span>
        <span style="font-size: 20px;
        text-align: center;">
        <strong>GST No : </strong>${
          companyDetails?.getCompany?.relatedCompanyEntity?.[0].GSTIN ==
          undefined
            ? ""
            : companyDetails?.getCompany?.relatedCompanyEntity?.[0].GSTIN
        }
        </span>
        </div>
            </div>
        </div>
    <div>
    <table border="1" cellpadding="5" cellspacing="0" width="95%"
    style="margin-left: auto; margin-right: auto; margin-top:auto text-align: center;">
<thead style="background-color: #DADBDD; font-weight: bold;">
    <tr>
        <td>Credit Note Details</td>
        <td>Bill to Party</td>
        <td>Ship to Party</td>
    </tr>
</thead>
<tbody>
 <tr style="min-height: 100px">
 <td style="font-weight: bold;">Debit Note No : ${creditNoteNumber}</td>
 <td style="font-weight: bold;">Customer Name : ${data?.partyName?.label}</td>
 <td style="font-weight: bold;">Consignee Name : ${data?.partyName?.label}</td>
 </tr>
<tr style="min-height: 100px">
<td style="font-weight: bold;">Credit Note Date :  ${
    data.creditNoteDate === ""
      ? moment(new Date()).format("DD/MMM/YYYY")
      : moment(data.creditNoteDate).format("DD/MMM/YYYY")
  }</td>
<td style="font-weight: bold;">Customer Address:${
    data.partyName.value != ""
      ? `
    <span>
      ${
        billingAddressDetails.billingAddress !== ""
          ? billingAddressDetails.billingAddress.replace("**", ",")
          : data.billingAddress.replace("**", ",")
      }
    </span>
    ${
      billingAddressDetails.stateCD !== "" || stateName !== ""
        ? `
      <span

      >
        ${
          billingAddressDetails.stateCD !== ""
            ? billingAddressDetails.stateCD
            : stateName
        }
        ,${countryName}
      </span>`
        : `
      <span

      >
        ${countryName}

      </span>`
    }
`
      : ``
  }</td>
<td style="font-weight: bold;">Consignee Address : ${
    data.partyName.value != ""
      ? `
    <span>
    ${
      deliveryAddressDetails.deliveryAddress !== ""
        ? deliveryAddressDetails.deliveryAddress.replace(/[**  ,]+/g, ",")
        : data.deliveryAddress.replace(/[**  ,]+/g, ",")
    }
    </span>
    ${
      deliveryAddressDetails.stateCD !== "" || stateName !== ""
        ? `
      <span

      >
        ${
          deliveryAddressDetails.stateCD !== ""
            ? deliveryAddressDetails.stateCD
            : stateName
        }
        ,${countryName}
      </span>`
        : `
      <span

      >
        ${countryName}

      </span>`
    }
`
      : ``
  }</td
</tr>
<tr style="min-height: 100px">
<td style="font-weight: bold;">Reverse Charge (Y/N) : ${
    data.reverseChargeFlag == 1 ? "Yes" : "No"
  }</td>
<td></td>
<td></td
</tr>
<tr style="min-height: 100px">
<td style="font-weight: bold;">Credit Period : ${data.creditPeriod}</td>
<td style="font-weight: bold;">Contact Person</td>
<td></td
</tr>
<tr style="min-height: 100px">
<td  style="font-weight: bold;">Due Date : ${data.dueDate}</td>
<td style="font-weight: bold;">Customer GSTIN : ${
    partyDetails?.relatedPartyGstDetails?.[0].GSTIN == undefined
      ? ""
      : partyDetails?.relatedPartyGstDetails?.[0].GSTIN
  }</td>
<td style="font-weight: bold;">Consignee GSTIN,if any : ${data.gstin}</td
</tr>
<tr style="min-height: 100px">
<td></td>
<td style="font-weight: bold;">Place of Supply : ${stateOfSupply} </td>
<td style="font-weight: bold;">State Name :  ${
    deliveryAddressDetails.stateCD !== ""
      ? deliveryAddressDetails.stateCD
      : stateName
  }</td
</tr>
</tbody>
</table>
</div>
${
  itemEntry
    ? `<table border="1" cellpadding="5" cellspacing="0" width="95%"
        style="margin-left: auto; margin-right: auto; text-align: center;">
    <thead style="background-color: #DADBDD; font-weight: bold;">
        <tr>
            <td>#</td>
            <td>Item Name</td>
            <td>Rate</td>
            <td>Qty</td>
            <td>Discount</td>
            <td>Gross Amt</td>
            <td colspan="2">CGST</td>
            <td colspan="2">SGST</td>
            <td colspan="2">IGST</td>
            <td>GST Cess</td>
            <td style="text-align:right">Total</td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>Rate (%)</td>
            <td>Amount</td>
            <td>Rate (%)</td>
            <td>Amount</td>
            <td>Rate (%)</td>
            <td>Amount</td>
            <td></td>
            <td></td>
        </tr>
    </thead>
    <tbody>
        ${
          items &&
          items.length > 0 &&
          items.map((item, index) => {
            if (item.new != true)
              return `
        <tr style="min-height: 100px">
            <td>${index + 1}</td>
            <td>${item.name?.label}</td>
            <td>${item.rate}</td>
            <td>${item.qty}</td>
            <td>${item.dicount}</td>
            <td>${item.amount}</td>
            <td>${item.GSTRate}</td>
            <td>${
              data.placeOfSupply === "companyState"
                ? (
                    (Number(item.taxableAMount) * Number(item.GSTRate)) /
                    200
                  ).toFixed(2)
                : "0.00"
            }
                </td>
                <td>${item.GSTRate}</td>
                <td>${
                  data.placeOfSupply === "companyState"
                    ? (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    : "0.00"
                }
                </td>
                <td>${item.GSTRate}</td>
                <td>${
                  data.placeOfSupply !== "companyState"
                    ? (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        100
                      ).toFixed(2)
                    : "0.00"
                }
                </td>
                <td>${item.GSTCess}</td>
                <td>${Number(item.netAmount).toFixed(2)}</td>
        </tr>`;
          })
        }
    </tbody>
    <tfoot style="font-weight: bold; background-color: #DADBDD;">
        <tr>
            <td colspan="5" style="text-align: right">TOTAL</td>
            <td>${totAmount.toFixed(2)}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>${MoneyFormat(tabelTotAmount?.toFixed(2), "en-IN")}</td>
        </tr>
    </tfoot>
</table>`
    : `<table border="1" cellpadding="5" cellspacing="0" width="95%"
            style="margin-left: auto; margin-right: auto; text-align: center;">
        <thead style="background-color: #DADBDD; font-weight: bold;">
            <tr>
                <td>#</td>
                <td>Expense Ledger Account</td>
                <td>HSN/SAC Code</td>
                <td>Description</td>
                <td>Taxable Amount</td>
                <td colspan="2">CGST</td>
                <td colspan="2">SGST</td>
                <td colspan="2">IGST</td>
                <td>GST Cess</td>
                <td>Net Amount</td>
            </tr>
            <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>Rate (%)</td>
            <td>Amount</td>
            <td>Rate (%)</td>
            <td>Amount</td>
            <td>Rate (%)</td>
            <td>Amount</td>
            <td></td>
            <td></td>
        </tr>
        </thead>
        <tbody>
            ${
              nonItems &&
              nonItems.length > 0 &&
              nonItems.map((item, index) => {
                if (item.new != true)
                  return `
            <tr style="min-height: 100px">
                <td>${index + 1}</td>
                <td>${item.ledgerAccount.label}</td>
                <td>${item.HSN.value}</td>
                <td>${item.description}</td>
                <td>${MoneyFormat(item.taxAMount, "en-IN")}</td>
                <td>${item.GSTRate}</td>
                <td>${
                  data.placeOfSupply === "companyState"
                    ? (
                        (Number(item.taxAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    : "0.00"
                }
                    </td>
                    <td>${item.GSTRate}</td>
                    <td>${
                      data.placeOfSupply === "companyState"
                        ? (
                            (Number(item.taxAMount) * Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        : "0.00"
                    }
                    </td>
                    <td>${item.GSTRate}</td>
                    <td>${
                      data.placeOfSupply !== "companyState"
                        ? (
                            (Number(item.taxAMount) * Number(item.GSTRate)) /
                            100
                          ).toFixed(2)
                        : "0.00"
                    }
                    </td>
              
                <td>${MoneyFormat(
                  Number(item?.GSTCess).toFixed(2),
                  "en-IN"
                )}</td>
                <td>${MoneyFormat(
                  Number(item?.netAmount).toFixed(2),
                  "en-IN"
                )}</td>
            </tr>`;
              })
            }
        </tbody>
        <tfoot style="font-weight: bold; background-color: #DADBDD;">
            <tr>
                <td colspan="4" style="text-align: right">TOTAL</td>
                <td>${MoneyFormat(totTaxableAmount.toFixed(2), "en-IN")}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>${MoneyFormat(totGstCess.toFixed(2), "en-IN")}</td>
                 <td>${MoneyFormat(
                   nonItemwiseTableAmount.toFixed(2),
                   "en-IN"
                 )}</td>
            </tr>
        </tfoot>
    </table>`
}
    <div>
    <table border="1" cellpadding="5" cellspacing="0" width="95%"
    style="margin-left: auto; margin-right: auto; margin-top:auto text-align: center;">
<thead>
  
</thead>
<tbody>
<tr>
<td style= "background-color: #DADBDD; font-weight: bold">Description</td>
<td style="font-weight: bold;">Total Amount before Tax</td>
<td style="font-weight: bold;">${MoneyFormat(
    totTaxableAmount.toFixed(2),
    "en-IN"
  )}</td>
</tr>
<tr style="min-height: 100px">
<td style="font-weight: bold;" rowspan="4">${data.remarks}</td>
<td  style="font-weight: bold;">Discount</td>
<td style="font-weight: bold;"> ${
    Number(totAmount) - Number(totTaxableAmount) > 0
      ? MoneyFormat(
          (Number(totAmount) - Number(totTaxableAmount)).toFixed(2),
          "en-IN"
        )
      : "0.00"
  }</td>

</tr>
 <tr style="min-height: 100px">
 <td style="font-weight: bold;">Add CGST</td>
 <td style="font-weight: bold;">${
   data.placeOfSupply === "companyState"
     ? MoneyFormat((Number(totGST) / 2).toFixed(2), "en-IN")
     : "0.00"
 }</td>
 
 </tr>
<tr style="min-height: 100px">
<td style="font-weight: bold;">Add SGST</td>
<td style="font-weight: bold;"> ${
    data.placeOfSupply === "companyState"
      ? MoneyFormat((Number(totGST) / 2).toFixed(2), "en-IN")
      : "0.00"
  }</td>

</tr>
<tr style="min-height: 100px">
<td style="font-weight: bold;">Add IGST </td>
<td style="font-weight: bold;">${
    data.placeOfSupply !== "companyState"
      ? MoneyFormat(Number(totGST).toFixed(2), "en-IN")
      : "0.00"
  }</td>
</tr>
<tr style="min-height: 100px">
<td style= "background-color: #DADBDD; font-weight: bold">Total Invoice amount in words </td>
<td style="font-weight: bold">Total GST Amount</td>
<td style="font-weight: bold">${MoneyFormat(totGST.toFixed(2), "en-IN")}</td>
</tr>
<tr>
<td rowspan="3"> <strong>
${toWords.convert(
  Number(totNetAmount.toFixed(2)) + Number(data.adjustments)
)}</strong></td>
<td style="font-weight: bold">Total GST Cess</td>
<td style="font-weight: bold">${MoneyFormat(
    totGstCess.toFixed(2),
    "en-IN"
  )}</td>
</tr>
<tr style="min-height: 100px">
<td style="font-weight: bold">Total Amount after Tax </td>
<td style="font-weight: bold">${MoneyFormat(
    (Number(totNetAmount.toFixed(2)) + Number(data.adjustments)).toFixed(2),
    "en-IN"
  )}</td>
</tr>
</tbody>
</table>
</div>
<div>
<table border="1" cellpadding="5" cellspacing="0" width="95%"
style="margin-left: auto; margin-right: auto; margin-top:auto text-align: center;">
<thead>
<tr>
    <td style="text-align:center; font-weight: bold; font-size:20px; ">HSN/SA Code Summary Table</td>
</tr>
</thead>
</table>
</div>
<div>
${
  itemEntry
    ? `
<table border="1" cellpadding="5" cellspacing="0" width="95%"
style="margin-left: auto; margin-right: auto; margin-top:auto text-align: center;">
<thead style= "background-color: #DADBDD; font-weight: bold">
<tr>
    <td>#</td>
    <td>HSN/SAC Code</td>
    <td>GST Rate (%)</td>
    <td>Taxable Value</td>
    <td>CGST</td>
    <td>SGST</td>
    <td>IGST</td>
    <td>Total</td>
</tr>
</thead>
<tbody>

${
  items &&
  items.length > 0 &&
  items.map((item, index) => {
    if (item.new != true)
      return `
<tr style="min-height: 100px">
<td>${index + 1}</td>
<td>${item?.HSN?.value}</td>
<td>${item.GSTRate}</td>
<td>${MoneyFormat(item.taxableAMount, "en-IN")}</td>
<td>${
        data.placeOfSupply === "companyState"
          ? ((Number(item.taxableAMount) * Number(item.GSTRate)) / 200).toFixed(
              2
            )
          : "0.00"
      }</td>
<td>${
        data.placeOfSupply === "companyState"
          ? ((Number(item.taxableAMount) * Number(item.GSTRate)) / 200).toFixed(
              2
            )
          : "0.00"
      }</td>
<td>${
        data.placeOfSupply !== "companyState"
          ? ((Number(item.taxableAMount) * Number(item.GSTRate)) / 100).toFixed(
              2
            )
          : "0.00"
      }</td>

<td>${
        data.placeOfSupply !== "companyState"
          ? (
              (Number(item.taxableAMount) * Number(item.GSTRate)) / 100 +
              Number(item.taxableAMount)
            ).toFixed(2)
          : (
              (Number(item.taxableAMount) * Number(item.GSTRate)) / 200 +
              (Number(item.taxableAMount) * Number(item.GSTRate)) / 200 +
              Number(item.taxableAMount)
            ).toFixed(2)
      }</td>
</tr>`;
  })
}
</tbody>
</table>`
    : `
<table border="1" cellpadding="5" cellspacing="0" width="95%"
style="margin-left: auto; margin-right: auto; margin-top:auto text-align: center;">
<thead style= "background-color: #DADBDD; font-weight: bold">
<tr>
    <td>#</td>
    <td>HSN/SAC Code</td>
    <td>GST Rate (%)</td>
    <td>Taxable Value</td>
    <td>CGST</td>
    <td>SGST</td>
    <td>IGST</td>
    <td>Total</td>
</tr>
</thead>
<tbody>
${
  nonItems &&
  nonItems.length > 0 &&
  nonItems.map((item, index) => {
    if (item.new != true)
      return `
<tr style="min-height: 100px">
<td>${index + 1}</td>
<td>${item?.HSN?.value}</td>
<td>${item.GSTRate}</td>
<td>${MoneyFormat(item.taxAMount, "en-IN")}</td>
<td>${
        data.placeOfSupply === "companyState"
          ? ((Number(item.taxAMount) * Number(item.GSTRate)) / 200).toFixed(2)
          : "0.00"
      }</td>
<td>${
        data.placeOfSupply === "companyState"
          ? ((Number(item.taxAMount) * Number(item.GSTRate)) / 200).toFixed(2)
          : "0.00"
      }</td>
<td>${
        data.placeOfSupply !== "companyState"
          ? ((Number(item.taxAMount) * Number(item.GSTRate)) / 100).toFixed(2)
          : "0.00"
      }</td>

<td>${
        data.placeOfSupply !== "companyState"
          ? (
              (Number(item.taxAMount) * Number(item.GSTRate)) / 100 +
              Number(item.taxAMount)
            ).toFixed(2)
          : (
              (Number(item.taxAMount) * Number(item.GSTRate)) / 200 +
              (Number(item.taxAMount) * Number(item.GSTRate)) / 200 +
              Number(item.taxAMount)
            ).toFixed(2)
      }</td>
</tr>`;
  })
}
</tbody>
</table>`
}
</div>
     <div style="min-height: 250px; margin-left: auto; margin-right: auto; width:95%;
                border: double; border-width: 2px; border-color: black; margin-top: 15px">
         <div style="width: 50%; float: left;">
             <div style="font-size: 17px; margin-top: 10px; margin-bottom: 25px; padding-left: 10px; font-weight:bold">
                 Bank Details
             </div>
             <div>
             <div style="display: flex; flex-direction:column; line-height: 1.8;">
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span style="font-weight:bold;">Account Name : ${
                       bankDetails?.BankAccountName == undefined
                         ? ""
                         : bankDetails?.BankAccountName
                     }</span>
                     <span  style="font-weight:bold;"></span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span  style="font-weight:bold;">Account Number : ${
                       bankDetails?.BankAccountNumber == undefined
                         ? ""
                         : bankDetails?.BankAccountNumber
                     }</span>
                     <span  style="font-weight:bold;"></span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span  style="font-weight:bold;">Bank : ${
                       bankDetails?.BankName == undefined
                         ? ""
                         : bankDetails?.BankName
                     }</span>
                     <span  style="font-weight:bold;"></span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span  style="font-weight:bold;">IFSC Code : ${
                       bankDetails?.IFSCCode == undefined
                         ? ""
                         : bankDetails?.IFSCCode
                     }</span>
                     <span  style="font-weight:bold;">
                       </span>
                 </div>
             </div>
         </div>
       
         </div>
     </div>

    <div style="margin-left: auto; margin-right: auto; width:95%;
                 border: double; border-width: 2px; border-color: black; margin-top: 15px">
        <div style="padding:10px;">
            <strong>TERMS AND CONDITIONS : </strong>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
            when an unknown printer took a galley of type and scrambled it to make a type specimen book.
            It has survived not only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset
            sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
            Aldus PageMaker including versions of Lorem Ipsum.
        </div>
    </div>
    <div style="margin-left: auto; margin-right: auto; width:95%; display:flex; flex-direction:row;">
        <div style="width: 40%; padding:5px; border: 1px solid black;">
            <span>
                <strong>DECLARATION : </strong>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
            </span>
        </div>
        <div style="width: 35%; padding:5px; border: 1px solid black;">
            <div display:flex; flex-direction:column;>
                <div style="text-align: center;">
                    <strong>Received The Item In Good Condition</strong>
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    Customer Name and Signature
                </div>
            </div>
        </div>
        <div style="width: 25%; padding:5px; border: 1px solid black;">
            <div display:flex; flex-direction:column;>
                <div style="text-align: center;">
                    <strong>For ${companyDetails?.getCompany?.CompanyName.toUpperCase()}</strong>
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    Authorized Signature
                </div>
            </div>
        </div>
    </div>
</body>
</html>

    `;
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Preview Credit Note
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: "white",
              padding: "15px",
              // display : "flex",
              // flexDirection : "row"
              // height:{xs:"400px",sm:'auto'},
              // overflowY:{xs:'scroll',sm:'hidden'},
              // minWidth:{xs:'400px'}
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </Box>
          <Box
            sx={{
              // position: 'sticky', bottom: 0, left: 0,
              bgcolor: "background.paper",
              paddingY: 3,
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                fontSize: "12px",
                marginBottom: { xs: "20px", md: "0px" },
                marginLeft: { xs: "0px", sm: "20px" },
              }}
            >
              Cancel
            </Button>

            <Button
              onClick={handlePrint}
              variant="contained"
              sx={{
                fontSize: "12px",
                marginBottom: { xs: "20px", md: "0px" },
                marginLeft: { xs: "0px", sm: "20px" },
                marginRight: 25,
                color: "#fff",
              }}
            >
              Print
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default PreviewGstCreditNote;
